module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc19-b8e2d61cfbb8d1b05ba4b6dc52b614f1.jpg";